import React from "react";
import FirebaseContext from "../../firebase/context";
import { TextField, Button } from "@material-ui/core";

const style = {
  paper: {
    marginTop: 9,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: 5,
    backgroundColor: "red"
  },
  form: {
    width: "100%",
    marginTop: 8
  },
  submit: {
    marginTop: 10,
    marginBottom: 20
  }

}

function ForgotPassword() {
  const { firebase } = React.useContext(FirebaseContext);
  const [resetPasswordEmail, setResetPasswordEmail] = React.useState("");
  const [isPasswordReset, setIsPasswordReset] = React.useState(false);
  const [passwordResetError, setPasswordResetError] = React.useState(null);

  async function handleResetPassword() {
    try {
      await firebase.resetPassword(resetPasswordEmail);
      setIsPasswordReset(true);
      setPasswordResetError(null);
    } catch (err) {
      console.error("Error sending email", err);
      setPasswordResetError(err.message);
      setIsPasswordReset(false);
    }
  }

  return (
    <div>
      <TextField
        variant="outlined"
        label="E-Mail"
        name="email"
        type="email"
        placeholder="Ingrese su cuenta de Email"

        margin="normal"
        onChange={event => setResetPasswordEmail(event.target.value)}
      />

      <div>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="button"
          style={style.submit}
          onClick={handleResetPassword}
        >
          Reset Password
            </Button>
        <input
          type="email"
          className="input"
          placeholder="Provide your account email"
          onChange={event => setResetPasswordEmail(event.target.value)}
        />
        <button className="button" onClick={handleResetPassword}>
          Reset Password
        </button>
      </div>
      {isPasswordReset && <p>Verifica tu email para resetear tu password</p>}
      {passwordResetError && <p className="error-text">{passwordResetError}</p>}
    </div>
  );
}

export default ForgotPassword;